import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Input from "@/components/input/Input"
import { faTrashCan } from "@fortawesome/free-solid-svg-icons"
import DefaultLayout from "@/layouts/Default"
import Checkbox from "@/components/Checkbox"
import FormContainer from "../components/FormContainer"
import OrderSummaryCard from "../components/OrderSummaryCard"
import { useEffect, useRef, useState, useLayoutEffect } from "react"
import { Button } from "@/components/Button"
import message from "@/assets/icons/message.webp"
import phone from "@/assets/icons/phone.webp"
import location from "@/assets/icons/location.webp"
import CartAPI from "@/app/api/di-sana/cart/cart"
import { useGlobalContext } from "@/global/GlobalContext"
import { formatNumber, handleError, handleNegativeVal } from "@/app/utils/helpers"
import ImageSkeleton from "@/components/skeletons/ImageSkeleton"
import { useForm } from "react-hook-form"
import ContainerSkeleton from "@/components/skeletons/ContainerSkeleton"
import { useNavigate, useSearchParams } from "react-router-dom"
import { productSchema } from "@/app/utils/validation"
import ProcessModal from "@/components/ProcessModal"
import Pagination from "@/components/Pagination"
import clsx from "clsx"
import { capitalizeFirstLetter } from "@/app/utils/helpers"
import { useDispatch } from "react-redux"
import { loadOrderCount } from "@/app/redux/features/order/orderSlice"
import InputDropdown1 from "@/components/input/InputDropdown1"
import ShippingAPI from "@/app/api/di-sana/transaction/checkout/shipping"
import CourierCard from "../components/CourierCard"
import Cookies from "js-cookie"
import CryptoHelper from "@/app/utils/crypto"
const cartApi = new CartAPI()
const shippingApi = new ShippingAPI()
const cryptoHelper = new CryptoHelper()

const Cart = () => {
  const { notifyError, locSearch, setProcessSaveModal, updateUserInCart, setUpdateUserInCart, userDetail, regions, authStore, notifySuccess } = useGlobalContext()
  const { register: registerA, handleSubmit: handleSubmitA, setValue: setValueA, getValues: getValuesA, reset: resetA } = useForm()
  const { register: registerB, handleSubmit: handleSubmitB, setValue: setValueB, getValues: getValuesB, reset: resetB } = useForm()
  const navigate = useNavigate()
  const [onReq, setOnReq] = useState(false)
  const [onReqUserDetail, setOnReqUserDetail] = useState(true)
  const [isCalculating, setIsCalculating] = useState(false)
  const [onSaving, setOnSaving] = useState(false)
  const [tempPurchaseItems, setTempPurchaseItems] = useState([null])
  // const [initQuantities, setInitQuantities] = useState([null])
  const [formUser, setFormUser] = useState({})
  const [isEdited, setIsEdited] = useState(false)
  const [editAmount, setEditAmount] = useState(false)
  const [isCheckOut, setIsCheckOut] = useState(false)
  const deletedIds = useRef([])
  const [modalContent, setModalContent] = useState(null)
  const [modalContentCourier, setModalContentCourier] = useState(null)
  const deletedTotal = useRef(0)
  const [subTotal, setSubTotal] = useState(0)
  const [totalWeight, setTotalWeight] = useState(0)
  const [purchaseItem, setPurchaseItem] = useState({})
  const [shippingServs, setShippingServs] = useState([])
  const [deliveryFee, setDeliveryFee] = useState(0)
  const [selectedServ, setSelectedServ] = useState(null)
  const [savedCourier, setSavedCourier] = useState(null)
  const [isVisible, setIsVisible] = useState(true);
  const [selectedExp, setSelectedExp] = useState("")
  const layoutRef = useRef()
  const country = useRef("ID")
  const page = useRef(1)
  const sectionIndex = useRef(0)
  const lastPage = useRef(0)
  const hasLoaded = useRef(false)
  // const pageNumbers = useRef([])
  const [pageNumbers, setPageNumbers] = useState([])
  const totalRef = useRef(null)
  const searchRegionRef = useRef(null)
  const prevPage = useRef(0)
  const lastYRef = useRef(window.scrollY)
  const pageLimit = 5
  const [searchParams, setSearchParams] = useSearchParams()
  const dispatch = useDispatch()
  const userData = authStore.user
  const defaultErr2 = {
    country: "",
    name: "",
    email: "",
    phone: "",
    region: "",
    address: "",
  }
  const [errors2, setErrors2] = useState(defaultErr2)
  const [reqRegions, setReqRegions] = useState(true)
  const [reqServ, setReqServ] = useState(false)

  useLayoutEffect(() => {
    const queryParams = new URLSearchParams(locSearch)
    const currPage = queryParams.get("page")

    if (currPage) page.current = parseInt(currPage)
  }, [])

  useEffect(() => {
    setOnReqUserDetail(true)
    layoutRef.current.getUserDetail()
    loadData()
  }, [])

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        const entry = entries[0]
        setIsVisible(!entry.isIntersecting)
      },
      { threshold: 0.1 }
    )

    const handleScroll = () => {
      const currentY = window.scrollY
      if (currentY != lastYRef.current) {
        if (currentY > lastYRef.current && totalRef.current) observer.observe(totalRef.current)

        lastYRef.current = currentY
      }
    }

    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
      if (totalRef.current) observer.unobserve(totalRef.current)
    }
  }, [])

  useEffect(() => {
    if (purchaseItem) {
      if (purchaseItem.carts?.length > 0) {
        let tempQuantities = []
        tempQuantities = purchaseItem.carts.map(item => ({ ...item }))
        setTempPurchaseItems(tempQuantities)
        // setInitQuantities(tempQuantities)
      } else {
        setTempPurchaseItems([])
        // setInitQuantities([])
      }
    }
  }, [purchaseItem])

  useEffect(() => {
    if (tempPurchaseItems.length > 0) {
      const currPage = searchParams.get("page")

      if (!hasLoaded.current || !!currPage) {
        let tempDeletedIds = []
        let totalPrice = 0
        let totalWeight = 0

        for (let i in tempPurchaseItems) {
          if (tempPurchaseItems[i]?.is_checked) {
            tempDeletedIds.push(tempPurchaseItems[i]?.id)
            totalPrice += tempPurchaseItems[i]?.total_price
            totalWeight += tempPurchaseItems[i]?.total_weight
          }
        }

        handleSubTotal(true, totalPrice)
        handleTotalWeight(true, totalWeight)
        deletedIds.current = tempDeletedIds

        initPagination(lastPage.current);
        hasLoaded.current = tempPurchaseItems.length == purchaseItem.carts?.length
      }
    } else {
      handleSubTotal(true, 0)
      handleTotalWeight(true, 0)
    }
  }, [tempPurchaseItems])

  useEffect(() => {
    if (userDetail) {
      applyAllField()
    }
  }, [userDetail])

  useEffect(() => {
    // TODO: nanti ada kasus, user gak punya alawat but nanti kan dia update alamatnya, nah ini perlu req lagi
    if (userDetail.address && purchaseItem) {
      if (purchaseItem.carts?.length > 0) {
        const checkedItems = purchaseItem.carts.filter(item => item.is_checked)

        if (checkedItems.length > 0) {
          calculateCost(userDetail.ro_destinations?.ro_id.toString())
        } else {
          if (savedCourier) {
            resetCourierData()
          } else {
            setIsCalculating(false)
          }
        }
      } else {
        if (savedCourier) resetCourierData()
      }
    }
  }, [userDetail, purchaseItem])

  useEffect(() => {
    if (shippingServs.length > 0) {
      setSavedCourier(shippingServs[0])
      setDeliveryFee(shippingServs[0].cost)
      setIsCalculating(false)
    }
  }, [shippingServs])

  useEffect(() => {
    if (selectedExp) chooseCourierServ()
  }, [selectedExp])

  const resetForm = () => {
    setErrors2(defaultErr2)
    applyAllField()
    setIsEdited(false)
  }

  const openEditForm = (isEdit) => {
    setIsEdited(isEdit);
  }

  const applyAllField = () => {
    setValueB("id", userDetail.id)
    setValueB("country", "Indonesia")
    setValueB("name", userDetail.name)
    setValueB("email", userDetail.email)
    setValueB("phone", userDetail.phone)
    setValueB("ro_destination_id", userDetail.ro_destinations?.ro_id)
    // TODO: nanti aktifkan kalau sudah ada country yg dikirim dari backend, sementara default "Indonesia"
    // setValueB("country", userDetail.country)
    setValueB("region", userDetail.ro_destinations?.label)
    setValueB("address", userDetail.address)
  }

  const saveUserData = async () => {
    setOnSaving(true)
    const err = await layoutRef.current.handleUpdateUser(formUser)
    if (err) {
      if (typeof err.error[0] == "string") {
        notifyError(err.error[0])
      } else {
        const newErrs = handleError(err)
        setErrors2({ ...newErrs })
      }
    } else {
      await layoutRef.current.getUserDetail()
      resetForm()
    }

    setUpdateUserInCart(false)
    setProcessSaveModal(false)
    setOnSaving(false)
  }

  const onCancel = () => {
    resetForm()
  }

  const calculateSubTotal = async (checked, idx) => {
    setIsCalculating(true)
    const tempQuantities = [...tempPurchaseItems]
    const tempIds = [...deletedIds.current]
    const qty = tempPurchaseItems[idx].qty
    const selected = tempQuantities[idx].id

    const totalPrice = parseFloat(qty) * tempQuantities[idx].product.price
    const totalWeight = parseFloat(qty) * tempQuantities[idx].product.weight
    tempQuantities[idx].is_checked = checked
    if (checked) {
      tempIds.push(selected)
    } else {
      let removedIdx = tempIds.indexOf(selected)
      if (removedIdx != -1) tempIds.splice(removedIdx, 1)
      deletedIds.current = [selected]
    }

    deletedIds.current = tempIds
    handleSubTotal(checked, totalPrice)
    handleTotalWeight(checked, totalWeight)

    await toggleCheck(selected)
    if (savedCourier) {
      resetSavedCourier()
    } else {
      await calculateCost(userDetail.ro_destinations?.ro_id.toString())
    }
  }

  const calculateQuantity = async (val, idx, productId) => {
    setIsCalculating(true)
    if (tempPurchaseItems[idx].qty == 1 && val < 0) return
    let tempQuantities = [...tempPurchaseItems]
    const checked = tempQuantities[idx].is_checked
    const newVal = tempQuantities[idx].qty + val
    const temptTotal = tempQuantities[idx].total_price + (tempQuantities[idx].product.price * val)
    let addition = val * tempQuantities[idx].product.price
    let additionW = val * tempQuantities[idx].product.weight
    tempQuantities[idx].qty = newVal < 1 ? 1 : newVal
    tempQuantities[idx].total_price = temptTotal
    await editCartAmount(tempQuantities[idx].qty, productId)

    if (checked) {
      handleSubTotal(checked, addition)
      handleTotalWeight(checked, additionW)
    }
    setTempPurchaseItems(tempQuantities)
    setEditAmount(false)
  }

  const changeQuantity = async (val, idx, productId) => {
    setIsCalculating(true)
    let tempQuantities = [...tempPurchaseItems]
    let totalPrice = 0
    let totalW = 0
    const checked = tempPurchaseItems[idx].is_checked
    const newVal = val.charAt(0) == "0" ? val.slice(1) : val
    const valStr = !newVal ? 1 : handleNegativeVal(newVal)
    const temptQty = tempQuantities[idx].qty
    const temptTotal = tempQuantities[idx].total_price
    const temptTotalW = tempQuantities[idx].total_weight
    const productPrice = tempQuantities[idx].product.price
    const productWeight = tempQuantities[idx].product.weight

    if (temptQty > val) {
      if (!val) val = 1
      totalPrice = productPrice * (-(temptQty - val))
      totalW = productWeight * (-(temptQty - val))
    } else if (temptQty < val) {
      totalPrice = productPrice * (val - temptQty)
      totalW = productWeight * (val - temptQty)
    } else {
      totalPrice = 0
      totalW = 0
    }

    if (checked && val > 0) {
      handleSubTotal(checked, totalPrice)
      handleTotalWeight(checked, totalW)
    }

    tempQuantities[idx].qty = parseInt(valStr)
    tempQuantities[idx].total_price = temptTotal + totalPrice
    tempQuantities[idx].total_Weight = temptTotalW + totalW
    await editCartAmount(parseInt(valStr), productId)

    setTempPurchaseItems(tempQuantities)
    setEditAmount(false)
  }

  const editCartAmount = async (qty, productId) => {
    setEditAmount(true)
    const err = await addCart(qty, productId)

    if (err) {
      if (typeof err.error[0] == "string") {
        notifyError(err.error[0])
      } else {
        const newErrs = handleError(err)
        notifyError(newErrs.product_id ? newErrs.product_id : newErrs.qty)
      }
    }
  }

  const handleSubTotal = (checked, totalPrice) => {
    let tempSubTotal = 0
    let currSubtotal = subTotal

    setSubTotal(prev => {
      if (prevPage.current != page.current) {
        prevPage.current = page.current
        currSubtotal = 0
      }
      if (checked) {
        if (currSubtotal) {
          tempSubTotal = prev + totalPrice
        } else {
          tempSubTotal += totalPrice
        }
      } else {
        if (prev) {
          tempSubTotal = prev - totalPrice
        } else {
          tempSubTotal = 0
        }
      }

      return tempSubTotal
    })
  }

  const handleTotalWeight = (checked, totalW) => {
    let tempTotalWeight = 0
    let currTotalWeight = totalWeight

    setTotalWeight(prev => {
      if (prevPage.current != page.current) {
        prevPage.current = page.current
        currTotalWeight = 0
      }
      if (checked) {
        if (currTotalWeight) {
          tempTotalWeight = prev + totalW
        } else {
          tempTotalWeight += totalW
        }
      } else {
        if (prev) {
          tempTotalWeight = prev - totalW
        } else {
          tempTotalWeight = 0
        }
      }

      return tempTotalWeight
    })
  }

  const handleDelete = (id) => {
    setModalContent({ title: "Confirmation", msg: "Are you sure to delete your purchase items?", isOpen: true, isConfirm: true })

    deletedIds.current = [id]
    collectDeletedData()
  }

  const collectDeletedData = () => {
    const deleted = tempPurchaseItems.filter(item => deletedIds.current.includes(item.id))

    deletedTotal.current = deleted[0]?.is_checked ? deleted[0]?.total_price : 0
  }

  const onSubmitUser = (formData) => {
    setModalContent({ title: "Confirmation", msg: "Are you sure to change your details?", isOpen: true, isProcess: true })
    const saved = {
      id: formData.id,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      address: formData.address,
      ro_destination_id: formData.ro_destination_id,
    }
    setFormUser(saved)
    setUpdateUserInCart(true)
  }

  const checkKeyDown = (e) => {
    // preventing form sfom submiting
    if (e.key === "Enter") e.preventDefault();
  }

  const checkOut = async () => {
    setIsCheckOut(true)
    // await markCheckOutProducts()
    if (savedCourier) {
      const encrypted = cryptoHelper.encrypt(JSON.stringify(savedCourier))
      Cookies.set("shippingDetail", encrypted)
      navigate("/cart/checkout")
    }
    setIsCheckOut(false)
  }

  const initPagination = (rowDataLength) => {
    const currPage = searchParams.get("page")
    const pages = []
    if (currPage > pageLimit) sectionIndex.current = Math.floor((currPage - 1) / pageLimit)

    if (rowDataLength >= pageLimit) {
      const start = sectionIndex.current * pageLimit + 1
      for (let i; i < pageLimit; i++) {
        let calculated = start + i

        if (calculated > rowDataLength) break
        // pageNumbers.current.push(calculated)
        // pages.push(calculated)
      }

      setPageNumbers(pages)
    } else {
      // pageNumbers.current = Array.from({ length: rowDataLength }, (_, i) => i + 1)
      setPageNumbers(Array.from({ length: rowDataLength }, (_, i) => i + 1))
    }
  }

  const toPage = async (currPage) => {
    page.current = parseInt(currPage)
    setSearchParams({ page: currPage })
    await loadData()
  }

  const toPrevPage = async () => {
    const currPage = page.current
    // if (currPage == pageNumbers.current[0]) {
    if (currPage == pageNumbers[0]) {
      sectionIndex.current--
      const end = sectionIndex.current * (pageLimit) + 1
      const currPageNumbers = Array.from({ length: pageLimit }, (_, i) => end + i)
      // pageNumbers.current = currPageNumbers
      setPageNumbers(currPageNumbers)
    }
    page.current = currPage - 1

    setSearchParams({ page: page.current })
    await loadData()
  }

  const toNextPage = async () => {
    const currPage = page.current
    let currPageNumbers = []

    // if (currPage == pageNumbers.current[pageLimit - 1]) {
    if (currPage == pageNumbers[pageLimit - 1]) {
      sectionIndex.current++
      const start = sectionIndex.current * (pageLimit) + 1
      for (let i = 0; i < pageLimit; i++) {
        let calculated = start + i

        if (calculated > lastPage.current) break
        currPageNumbers.push(calculated)
      }

      // pageNumbers.current = currPageNumbers
      setPageNumbers(currPageNumbers)
    }
    page.current = currPage + 1

    setSearchParams({ page: page.current })
    await loadData()
  }

  const toggleSearchInput = () => searchRegionRef.current.classList.toggle("hidden")

  const hideSearchInput = (e) => {
    if (searchRegionRef.current && !searchRegionRef.current.contains(e.target) && !searchRegionRef.current.classList.contains("hidden")) toggleSearchInput()
  }

  const searchLocation = async (e) => {
    const region = getValuesB("region")

    if (e.key === "Enter") {
      if (region) {
        if (searchRegionRef.current.classList.contains("hidden")) searchRegionRef.current.classList.remove("hidden")
        setReqRegions(true)
        await layoutRef.current.getDomDestinations(region)
        setReqRegions(false)
      }
    }
  }

  const showCourierModal = () => {
    // if (!savedCourier) { //TODO: test, kalo cocok ini direset setiap kali buka modal courier, lalu user pilih ulang okelah, but kalo modal dicancel, savedCourier aman ndak? cek!
    setSelectedExp("")
    // setShippingServs([])
    setSelectedServ(savedCourier)
    // }

    setModalContentCourier({ title: "Choose Courier", isOpen: true, isProcess: true })
  }

  const chooseCourierServ = () => {
    setShippingServs([])
    calculateCost(userDetail.ro_destinations?.ro_id.toString())
  }

  const chooseShippingServ = (service) => {
    setSelectedServ(service)
  }

  const calculateDeliveryFee = () => {
    setDeliveryFee(selectedServ.cost)
    setSavedCourier(selectedServ)
  }

  const selectRegion = location => {
    setValueB("id", userData.id)
    setValueB("ro_destination_id", location.id)
    setValueB("region", capitalizeFirstLetter(location.label))
    setValueB("label", location.label)
    toggleSearchInput()
  }

  const resetSavedCourier = async () => {
    if (deletedIds.current.length > 0) {
      await calculateCost(userDetail.ro_destinations?.ro_id.toString())
    } else {
      resetCourierData()
    }
  }

  const resetCourierData = () => {
    setSavedCourier(null)
    setDeliveryFee(0)
    setShippingServs([])
    setIsCalculating(false)
  }

  // API request
  const loadData = async () => {
    setOnReq(true)
    try {
      let param = {
        page: page.current
      }
      const { data } = await cartApi.getWithPagination(param)
      setPurchaseItem(data.data);
      lastPage.current = data.data.last_page
    } catch (err) {
      notifyError(err.message)
    }
    setOnReq(false)
    setOnReqUserDetail(false)
  }

  const addCart = async (qty, productId) => {
    try {
      const insertedData = productSchema.safeParse({
        // TODO: kenapa aku ngirimnya berupa string? padahal BE nerimanya berupa integer
        qty: typeof qty != "string" ? qty.toString() : qty,
        product_id: productId,
      })

      if (!insertedData.success) return { error: insertedData.error.issues }

      const { data } = await cartApi.addAndUpdateCart(insertedData.data)
      if (data.code == 200) {
        if (savedCourier) resetSavedCourier()
        notifySuccess("Quantity of your order has been updated.")
      }
    } catch (err) {
      notifyError(err.message)
    }
  }

  const calculateCost = async (roDestinationId) => {
    setReqServ(true)
    try {
      // if (totalWeight > 0) {
      const param = {
        destination_id: roDestinationId,
      }
      // setTimeout(() => {
      //   setShippingServs(dataShippingService)
      // }, 5000)
      // TODO: nanti uncomment
      const { data } = await shippingApi.calculateCost(param)
      if (data.code == 200) {
        setShippingServs(data.data);
      }
    } catch (err) {
      if (err.status != 404) notifyError(err.message)
      resetCourierData()
      // it happens when error requesting data from be/no purchase item checked
      // setSavedCourier(null)
      // setDeliveryFee(0)
      // setShippingServs([])
      // setIsCalculating(false)
    }
    setReqServ(false)
  }

  const toggleCheck = async (id) => {
    try {
      const { data } = await cartApi.toggleCheck(id)
      if (data.code == 200) {
        notifySuccess(data.message)
      }
    } catch (err) {
      notifyError(err.message)
    }
  }

  const deletePurchaseItems = async () => {
    if (deletedIds.current.length <= 0) return notifyError("No data selected!")
    setOnReq(true)
    setIsCalculating(true)
    try {
      let param = {
        ids: deletedIds.current
      }
      const { data } = await cartApi.deleteMultiple(param)

      if (data.code == 200) {
        await dispatch(loadOrderCount()).unwrap()
        const tempSubTotal = subTotal
        setSubTotal(tempSubTotal - deletedTotal.current)
        notifySuccess("Your order was removed from your cart!")
        await loadData()
        deletedTotal.current = 0
      }
      setProcessSaveModal(false)
    } catch (err) {
      notifyError(err.message)
    }
    setIsCalculating(false)
    setOnReq(false)
  }

  return (
    <>
      <ProcessModal pModalContent={modalContent} processModal={updateUserInCart ? saveUserData : deletePurchaseItems} />
      <ProcessModal pModalContent={modalContentCourier} processModal={calculateDeliveryFee}>
        {/* <div> */}
        {/* <div className="mb-4 border-b-[1.5px] border-b-[#bc9c5c] border-opacity-50">
            <span className="text-[#6e605d] font-agcasmlt font-extralight text-xl">Choose Available Courier</span>
          </div> */}
        <div>
          {!reqServ ?
            shippingServs.length > 0 ?
              shippingServs.map((s, i) => (
                <div key={i}>
                  <CourierCard courierData={s} atClickCard={() => chooseShippingServ(s)} custCardCls={clsx("hover:bg-light-gray mb-1", { "bg-light-gray": selectedServ && selectedServ.service == s.service })} checked={selectedServ && selectedServ.service == s.service ? true : false} />
                </div>
              ))
              :
              <div className="font-agcasmlt font-light text-base text-[#9f978e] py-3 px-2 bg-light-gray border mb-1">
                Please select a courier to proceed!
              </div>
            :
            <div className="font-agcasmlt font-light text-base text-[#9f978e] py-3 px-2 bg-light-gray border mb-1">
              Requesting courier list ...
            </div>
          }
        </div>
        {/* </div> */}
      </ProcessModal>
      <DefaultLayout ref={layoutRef} noHero bgColor="bg-white">
        <section onClick={e => hideSearchInput(e)} className="px-6 sm:px-10 lg:px-14">
          <div className="overflow-x-auto border-[1.5px] border-[#bc9c5c]">
            <table className="w-full max-lg:w-[1000px]">
              <caption className="bg-[#bc9c5c] font-agcasmlt font-extralight text-2xl sm:text-3xl md:text-4xl text-white text-left pt-3.5 pb-2.5 pl-6">Shopping Cart</caption>
              <thead>
                <tr className="border-b-[1.5px] border-b-[#bc9c5c]">
                  <th className="text-[#6e605d] font-agcasmlt font-normal text-lg sm:text-xl lg:text-2xl text-left pt-6 pb-3 px-8 w-[40%]">Product Code</th>
                  <th className="text-[#6e605d] font-agcasmlt font-normal text-lg sm:text-xl lg:text-2xl text-center pt-6 pb-3 px-8 w-[20%]">Quantity</th>
                  <th className="text-[#6e605d] font-agcasmlt font-normal text-lg sm:text-xl lg:text-2xl text-center pt-6 pb-3 px-8 w-[20%]">Price</th>
                  <th className="text-[#6e605d] font-agcasmlt font-normal text-lg sm:text-xl lg:text-2xl text-center pt-6 pb-3 px-8 w-[20%]">Total</th>
                  <th className="text-[#6e605d] font-agcasmlt font-normal text-lg sm:text-xl lg:text-2xl text-center pt-6 pb-3 px-8 w-[20%]">Action</th>
                </tr>
              </thead>
              <tbody>
                {onReq ?
                  <tr className="">
                    <td className="py-5 px-6">
                      <div className="flex">
                        <div className="my-auto mr-4 ">
                          <Checkbox disabled={purchaseItem.carts?.length <= 0} />
                        </div>
                        <div className="mr-2">
                          <ContainerSkeleton custH="h-[90px] sm:h-[100px] md:h-[148px]" custW="w-[110px] sm:w-[130px] md:w-[190px]" custCls="border-2 border-[#dcd6d2]" />
                        </div>
                        <div className="my-auto">
                          <ContainerSkeleton custH="h-3.5 sm:h-5" custW="w-20" />
                        </div>
                      </div>
                    </td>
                    <td className="py-5 px-6">
                      <ContainerSkeleton custH="h-10 sm:h-12" custW="w-24 lg:w-32 2xl:w-36" custCls="mx-auto" />
                    </td>
                    <td className="py-5 px-6">
                      <div className="flex justify-center">
                        <ContainerSkeleton custH="h-3.5 sm:h-5" custW="w-20" />                      </div>
                    </td>
                    <td className="py-5 px-6">
                      <div className="flex justify-center">
                        <ContainerSkeleton custH="h-3.5 sm:h-5" custW="w-20" />
                      </div>
                    </td>
                    <td className="py-5 px-6 h-full">
                      <div className="flex justify-center">
                        <ContainerSkeleton custH="h-6" custW="w-5" />
                      </div>
                    </td>
                  </tr>
                  :
                  purchaseItem.carts?.length > 0 ?
                    purchaseItem.carts.map((p, i) => (
                      <tr key={i} className="">
                        <td className="py-5 px-6">
                          <div className="flex">
                            <div className="my-auto mr-4 ">
                              <Checkbox onChangeVal={(val) => { calculateSubTotal(val, i) }} isChecked={p.is_checked} />
                            </div>
                            <div className="mr-2">
                              <ImageSkeleton src={p?.product.photo} isDarker custCls="object-cover h-[90px] sm:h-[100px] md:h-[148px] w-[110px] sm:w-[130px] md:w-[190px] border-2 border-[#dcd6d2]" custH="h-[90px] sm:h-[100px] md:h-[148px]" custW="w-[110px] sm:w-[130px] md:w-[190px]" />
                            </div>
                            <div className="my-auto">
                              <span className="text-[#6e605d] font-light font-agcasmlt text-sm sm:text-xl">{p?.product.name}</span>
                              {/* TODO: perlu didiskusikan sama klien dulu */}
                              {/* <span className="text-[#6e605d] font-light font-agcasmlt text-sm sm:text-xl block">Variant:</span> */}
                            </div>
                          </div>
                        </td>
                        <td className="py-5 px-6">
                          {/* TODO: disabled tombol minus jika amount di input 1, disabled add jika pas jumlah stock, terapkan pada page product juga */}
                          <Input disabled={editAmount} defaultVal={tempPurchaseItems.length > 0 && tempPurchaseItems[i]?.qty} calculateQuantityVal={(val) => calculateQuantity(val, i, tempPurchaseItems[i]?.product.id)} onInputVal={(val) => changeQuantity(val, i, tempPurchaseItems[i]?.product.id)} spinner noLabel custCls="w-3/4 mx-auto" />
                        </td>
                        <td className="py-5 px-6">
                          <div className="flex justify-center">
                            <span className="text-[#6e605d] font-light font-agcasmlt text-sm sm:text-xl">IDR {formatNumber(p?.product.price)}</span>
                          </div>
                        </td>
                        <td className="py-5 px-6">
                          <div className="flex justify-center">
                            <span className="text-[#6e605d] font-light font-agcasmlt text-sm sm:text-xl">
                              {tempPurchaseItems[i]?.total_price &&
                                `IDR ${formatNumber(tempPurchaseItems[i]?.total_price)}`
                              }
                            </span>
                          </div>
                        </td>
                        <td className="py-5 px-6 h-full">
                          {/* <form onSubmit={handleSubmit(handleDelete)} className="flex justify-center"> */}
                          <div className="flex justify-center">
                            <button type="button" onClick={() => handleDelete(p?.id)} className="my-auto">
                              <FontAwesomeIcon icon={faTrashCan} size="lg" style={{ color: "#6e605d" }} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    )) :
                    <tr>
                      <td colSpan="5" className="py-5 px-6 text-center text-gray-500">No purchase available.</td>
                    </tr>
                }
              </tbody>
            </table>
          </div>
          <div>
            {/* TODO: move this ol tag to pagination component */}
            <ol className="flex mt-4 lg:mt-2 justify-center">
              {onReq ?
                Array.from({ length: 5 }, (_, i) => (
                  <li key={i}>
                    <ContainerSkeleton custH="h-8" custW="w-8" />
                  </li>
                ))
                :
                (purchaseItem && purchaseItem.carts?.length > 0) &&
                <Pagination dataArr={purchaseItem} page={page.current} pageNumbers={pageNumbers} goToPage={toPage} goToPrevPage={toPrevPage} goToNextPage={toNextPage} />
              }
            </ol>
          </div>
        </section>
        <section onClick={e => hideSearchInput(e)} className="pb-10">
          <div className="grid md:grid-cols-2 gap-8 md:gap-14 lg:gap-32 mt-12 px-4 md:px-12 lg:px-24">
            <div>
              <FormContainer title="Shipping Details" custW="w-full" useIcon onEdit={isEdited} openEditForm={openEditForm}>
                <div className="py-8">
                  {isEdited ? (
                    <div>
                      <form onSubmit={handleSubmitB(onSubmitUser)} onKeyDown={e => checkKeyDown(e)}>
                        <div className="mb-3">
                          <Input required disabled={!isEdited} type="text" name="fullName" placeholder="Full Name" id="fullName" isInput2 noLabel borderColor="border-[#bc9c5c]" custCls={errors2.name ? "border-red-600" : ""} errMsg={errors2.name} ref={{ ...registerB("name") }} />
                        </div>
                        <div className="mb-3">
                          <Input required disabled={!isEdited} type="text" name="phone" placeholder="Phone Number" id="phone" isInput2 noLabel borderColor="border-[#bc9c5c]" custCls={errors2.phone ? "border-red-600" : ""} errMsg={errors2.phone} ref={{ ...registerB("phone") }} />
                        </div>
                        <div className="mb-3">
                          <Input required disabled={!isEdited} type="text" name="email" placeholder="Email" id="email" isInput2 noLabel borderColor="border-[#bc9c5c]" custCls={errors2.email ? "border-red-600" : ""} errMsg={errors2.email} ref={{ ...registerB("email") }} />
                        </div>
                        <div className="mb-3">
                          <Input required disabled type="text" name="country" id="country" isInput2 noLabel borderColor="border-[#bc9c5c]" custCls={errors2.country ? "border-red-600" : ""} errMsg={errors2.country} ref={{ ...registerB("country") }} />
                        </div>
                        <InputDropdown1 regions={regions} reqRegions={reqRegions} errors={errors2} atKeyPress={e => searchLocation(e)} onSelectRegion={r => selectRegion(r)} ref={{ searchRegionRef: searchRegionRef, regionRef: { ...registerB("region") } }} />
                        <div>
                          <Input required disabled={!isEdited} type="text" name="address" placeholder="Address" id="address" isInput2 noLabel borderColor="border-[#bc9c5c]" custCls={errors2.address ? "border-red-600" : ""} errMsg={errors2.address} ref={{ ...registerB("address") }} />
                        </div>
                        <div className="mx-auto mt-8 flex justify-center gap-4 w-full">
                          <div className="w-2/5">
                            <Button type="submit" isSaving={onSaving} title="Save Changes" custCls="text-lg tracking-wide pt-1.5 pb-0.5 font-extralight" />
                          </div>
                          <div className="w-2/5">
                            <Button title="Cancel" processBtn onClickBtn={onCancel} onlyBorder borderColor="border-[#bc9c5c]" custCls="text-lg tracking-wide pt-1.5 pb-0.5 font-normal" />
                          </div>
                        </div>
                      </form>
                    </div>
                  ) : (
                    <div>
                      <div>
                        {onReqUserDetail ?
                          <ContainerSkeleton custH="h-3.5 sm:h-5" custW="w-full" />
                          :
                          <span className="text-[#6e605d] font-light font-agcasmlt text-sm sm:text-xl">{userDetail.name}</span>
                        }
                        <div className="flex items-center mt-1">
                          <div className="mr-3">
                            <img src={location} alt="" className="w-3 -mt-1" />
                          </div>
                          {onReqUserDetail ?
                            <ContainerSkeleton custH="h-3.5 sm:h-5" custW="w-full" />
                            :
                            <span className="text-[#6e605d] font-light font-agcasmlt text-[14px] sm:text-[20px] leading-[14px] sm:leading-[20px] block">
                              {userDetail.address && userDetail.ro_destinations ? `${userDetail.address}, ${capitalizeFirstLetter(userDetail.ro_destinations.label)}` :
                                userDetail.address ? `${userDetail.address}` :
                                  <button type="button" onClick={openEditForm} className="hover:text-[#9f978e]">Please fill your address first!</button>
                              }
                            </span>
                          }
                        </div>
                      </div>
                      <div className="mt-12">
                        <div className="flex items-center">
                          <div className="mr-3">
                            <img src={phone} alt="" className="w-3.5 -mt-0.5" />
                          </div>
                          {onReqUserDetail ?
                            <ContainerSkeleton custH="h-3.5 sm:h-5" custW="w-full" />
                            :
                            <span className="text-[#6e605d] font-light font-agcasmlt text-[14px] sm:text-[20px] leading-[14px] sm:leading-[20px]">{userDetail.phone}</span>
                          }
                        </div>
                        <div className="flex items-center mt-2">
                          <div className="mr-3">
                            <img src={message} alt="" className="w-4" />
                          </div>
                          {onReqUserDetail ?
                            <ContainerSkeleton custH="h-3.5 sm:h-5" custW="w-full" />
                            :
                            <span className="text-[#6e605d] font-light font-agcasmlt text-sm sm:text-xl">{userDetail.email}</span>
                          }
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </FormContainer>
              {(subTotal > 0 && userDetail.address) &&
                <FormContainer title="Shipping Service" custCls="w-full mt-2">
                  <div className="py-8">
                    {!reqServ && !isCalculating ?
                      savedCourier && <CourierCard courierData={savedCourier} atClickCard={showCourierModal} custCardCls="bg-light-gray" readOnly />
                      :
                      <div className="flex py-3 px-2">
                        <div className="w-2/3 flex items-center">
                          {/* <ContainerSkeleton custCls="mr-3" custW="w-16" custH="h-16" /> */}
                          <div className="w-3/4">
                            <ContainerSkeleton custH="h-3.5 sm:h-4 lg:h-5" custCls="mb-1" />
                            <ContainerSkeleton custH="h-3 sm:h-3.5 lg:h-4" />
                            <ContainerSkeleton custCls="mt-2" custH="h-3 sm:h-3.5 lg:h-4" />
                          </div>
                        </div>
                        <div className="w-1/3 flex justify-end mr-3">
                          <ContainerSkeleton custW="w-3/4" custH="h-3.5 sm:h-4 lg:h-5" />
                        </div>
                      </div>
                    }
                  </div>
                </FormContainer>
              }
            </div>
            <OrderSummaryCard isCalculating={isCalculating || reqServ || onReq} showFixed={isVisible} ref={totalRef} sendDataToParent={checkOut} disabledBtn={!deliveryFee} isSubmitForm={isCheckOut} deliveryFee={deliveryFee} subTotal={subTotal} btnName="Check Out Now" pageName="cart" custContainerCls="self-start md:top-16 sticky" />
          </div>
        </section>
      </DefaultLayout>
    </>
  )
}

export default Cart